import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classnames from 'classnames';
import { fetchStudents, createAssignment, fetchAssignment, uploadAssignmentMark } from '../../redux/action/facultyAction';
import FacultyHomeHelper from '../../Components/FacultyHomeHelper';
import { useHistory, Link } from 'react-router-dom';

const FacultyAssignment = () => {
  const store = useSelector((store) => store)
  const history = useHistory()
  const dispatch = useDispatch()
  const [subjectCode, setSubjectCode] = useState('');
  const [semester, setSemester] = useState('');
  const [section, setSection] = useState('');
  const [year, setYear] = useState('');
  const [assignmentNo, setAssignmentNo] = useState('');
  const [title, setTitle] = useState('');
  const [attachment, setAttachment] = useState('');
  const [description, setDescription] = useState('');
  const [submissionDate, setSubmissionDate] = useState('');
  const [error, setError] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [isLoading2, setIsLoading2] = useState(false)
  const department = store.faculty.faculty.faculty.department;
  const formHandler = (e) => {
    e.preventDefault();
    setIsLoading(false);
    setIsLoading(true);
    dispatch(fetchStudents(department, year, section, semester))
    dispatch(fetchAssignment(department, semester))

      .finally(() => {
        setIsLoading(false);
      });
  };
  const formHandler3 = (e, assignmentId, studentId) => {
    e.preventDefault();

    // Get the mark value from the form
    const mark = e.target.elements.mark.value;

    // Dispatch the action to upload the mark
    dispatch(uploadAssignmentMark(assignmentId, studentId, mark));
  };
  const getStudentName = (studentId) => {
    const student = store.faculty.fetchedStudents.find(
      (student) => student._id === studentId
    );

    return student ? student.name : "Unknown Student";
  };

  const formHandler2 = (e) => {

    const givenDate = new Date();
    const formattedGivenDate = givenDate.toISOString().split('T')[0]; // Format givenDate to YYYY-MM-DD
    const formattedSubmissionDate = new Date(submissionDate).toISOString().split('T')[0];

    console.log("submissionDate: " + formattedSubmissionDate, "givenDate: " + formattedGivenDate);
    e.preventDefault();
    setIsLoading(false); // Clear previous loading state
    setIsLoading(true);

    const formData = new FormData();

    // Append the form fields to the formData object
    formData.append("subjectCode", subjectCode);
    formData.append("title", title);
    formData.append("assignmentNo", assignmentNo);
    formData.append("semester", semester);
    formData.append("department", department);
    formData.append("description", description);
    formData.append("submissionDate", formattedSubmissionDate);
    formData.append("givenDate", formattedGivenDate);
    // Assuming that 'attachment' is the name of your file input
    formData.append("attachment", attachment);
    console.log(attachment)
    dispatch(createAssignment(formData))
      .finally(() => {
        setIsLoading(false);
      });
  };


  const handleAttachmentChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      let img = e.target.files[0]
      setAttachment(img);
      console.log(img)
    }
  };

  return (
    <div>
      {store.faculty.isAuthenticated ? (
        <>
          <div className="container-fluid p-0">
            <div className="d-flex">
              <div className="print-helper">
                <FacultyHomeHelper />
              </div>
              <div className="mx-1 w-100 ">
                <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                  <h3> <img src="/logo192.png" width={'50px'} alt="" />Assignments</h3>
                  <button onClick={() => window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                </div>
                <div className="col d-md-flex align-items-center justify-content-between ">
                  <form
                    className="d-md-flex align-items-center justify-content-start"
                    noValidate
                    onSubmit={formHandler}
                  >
                    <div className="form-group mx-2 ">
                      <label htmlFor="yearId">Year</label>
                      <select
                        onChange={(e) => setYear(e.target.value)}
                        className={classnames('form-control', {
                          'is-invalid': error.year
                        })}
                        id="yearId"
                      >
                        <option>Select</option>
                        <option value="I">1</option>
                        <option value="II">2</option>
                        <option value="III">3</option>
                        <option value="IV">4</option>
                      </select>
                      {error.year && (
                        <div className="invalid-feedback">{error.year}</div>
                      )}
                    </div>
                    <div className="form-group mx-2 ">
                      <label htmlFor="sectionId">Section</label>
                      <select
                        onChange={(e) => {
                          setSection(e.target.value);
                        }}
                        className={classnames('form-control', {
                          'is-invalid': error.section
                        })}
                        id="sectionId"
                      >
                        <option>Select</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                        <option value="D">D</option>
                      </select>
                      {error.section && (
                        <div className="invalid-feedback">{error.section}</div>
                      )}
                    </div>
                    <div className="form-group mx-2">
                      <label htmlFor="semesterId">Semester</label>
                      <select
                        onChange={(e) => {
                          setSemester(e.target.value);
                        }}
                        className={classnames('form-control', {
                          'is-invalid': error.section
                        })}
                        id="semesterId"
                      >
                        <option>Select</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                      </select>
                      {error.semester && (
                        <div className="invalid-feedback">{error.semester}</div>
                      )}
                    </div>

                    <div className="mt-3 position-relative">
                      {!isLoading && (
                        <button
                          type="submit"
                          className="btn btn-info btn-block print-helper"
                        >
                          <img
                            src="/image/search.svg"
                            className="mb-1"
                            alt=""
                          />{' '}
                          Search
                          <span className="badge badge-warning position-absolute top-0 end-0">
                            {store.faculty.fetchedStudents.length}
                          </span>
                        </button>
                      )}
                      {isLoading && (
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      )}
                    </div>

                  </form>
                  <button type="button" className="btn btn-success " data-bs-toggle="modal" data-bs-target="#exampleModalLabel24">
                    <img src="/image/add.svg" alt="" className='m-1' /> Create Assignment
                  </button>

                  <div class="modal fade" id="exampleModalLabel24" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h4 class="modal-title fs-5" id="exampleModalLabel">Create Assignment</h4>
                        </div>
                        <form noValidate onSubmit={formHandler2} className='w-100' encType="multipart/form-data">
                          <div className="modal-body">
                            <div className="row d-flex my-2 align-items-center justify-content-center w-100">
                              <div className="col-md-5">
                                <div className="form-group">
                                  <label htmlFor="departmentId">Department</label>
                                  <h5>{department}</h5>
                                  {error.department && (<div className="invalid-feedback">{error.department}</div>)}
                                </div>
                                <div className="form-group">
                                  <label htmlFor="semesterId">Semester</label>
                                  <select
                                    onChange={(e) => {
                                      setSemester(e.target.value);
                                    }}
                                    className={classnames('form-control', {
                                      'is-invalid': error.section
                                    })}
                                    id="semesterId"
                                  >
                                    <option>Select</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                  </select>
                                  {error.semester && (
                                    <div className="invalid-feedback">{error.semester}</div>
                                  )}
                                </div>
                                <div className="form-group">
                                  <label htmlFor="snameId">Subject Code</label>
                                  <input onChange={(e) => setSubjectCode(e.target.value)} type="text" className={classnames("form-control",
                                    {
                                      'is-invalid': error.subjectName
                                    })} id="snameId" />
                                  {error.subjectName && (<div className="invalid-feedback">{error.subjectName}</div>)}
                                </div>
                                <div className="form-group">
                                  <label htmlFor="assignmentNoId">Assignment No</label>
                                  <select
                                    onChange={(e) => setAssignmentNo(e.target.value)}
                                    className={classnames("form-control", {
                                      'is-invalid': error.assignmentNo
                                    })}
                                    id="assignmentNoId"
                                  >
                                    <option>Select</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                  </select>
                                  {error.assignmentNo && (<div className="invalid-feedback">{error.assignmentNo}</div>)}
                                </div>
                              </div>
                              <div className="col-md-5">

                                <div className="form-group">
                                  <label htmlFor="titleId">Title</label>
                                  <input
                                    onChange={(e) => setTitle(e.target.value)}
                                    type="text"
                                    className={classnames("form-control", {
                                      'is-invalid': error.title
                                    })}
                                    id="titleId"
                                  />
                                  {error.title && (<div className="invalid-feedback">{error.title}</div>)}
                                </div>

                                <div className="form-group">
                                  <label htmlFor="descriptionId">Description</label>
                                  <textarea
                                    onChange={(e) => setDescription(e.target.value)}
                                    className={classnames("form-control", {
                                      'is-invalid': error.description
                                    })}
                                    id="descriptionId"
                                  ></textarea>
                                  {error.description && (<div className="invalid-feedback">{error.description}</div>)}
                                </div>

                                <div className="form-group">
                                  <label htmlFor="submissionDateId">Date of Submission</label>
                                  <input
                                    onChange={(e) => setSubmissionDate(e.target.value)}
                                    type="date"
                                    className={classnames("form-control", {
                                      'is-invalid': error.submissionDate
                                    })}
                                    id="submissionDateId"
                                  />
                                  {error.submissionDate && (<div className="invalid-feedback">{error.submissionDate}</div>)}
                                </div>
                                <div className="form-group">
                                  <label htmlFor="attachmentId">Attachment</label>
                                  <small className='badge badge-warning'>images only</small>
                                  <input
                                    type="file"
                                    onChange={(e) => handleAttachmentChange(e)}
                                    className={classnames("form-control", {
                                      'is-invalid': error.attachment
                                    })}
                                    id="attachmentId"
                                    accept="image/*"
                                  />
                                  {error.attachment && (<div className="invalid-feedback">{error.attachment}</div>)}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                              Close
                            </button>
                            <button type="submit" className="btn btn-info m-3 ">
                              <img src="/image/add.svg" alt="" /> Add Assignment
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-center m-0">
                  <div className="col">
                    <table className="table table-bordered table-striped">
                      <thead className="thead-dark">
                        <tr>
                          <th scope="col">S.NO</th>
                          <th scope="col">Subject Name</th>
                          <th scope="col">Ass.No</th>
                          <th scope="col">Completed</th>
                          <th scope="col">Assign date</th>
                          <th scope="col">Due date</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {store.faculty.allAssignmentList.map((assignment, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{assignment.subjectCode}</td>
                            <td>{assignment.assignmentNo}</td>
                            <td>{assignment.students.length}/{store.faculty.fetchedStudents.length}</td>
                            <td>{new Date(assignment.givenDate).toLocaleDateString()}</td>
                            <td>{new Date(assignment.submissionDate).toLocaleDateString()}</td>

                            <td>
                              <button type="button" className=" btn-info w-100 mt-2 btn text-light" data-bs-toggle="modal" data-bs-target={`#exampleModal-${assignment._id}`}>
                                Open
                              </button>

                              <div className="modal fade" id={`exampleModal-${assignment._id}`} tabIndex="-1" aria-labelledby={`exampleModalLabel-${assignment._id}`} aria-hidden="true">
                                <div className="modal-dialog modal-lg">
                                  <div className="modal-content">
                                    <div className="modal-header">
                                      <h5 className="modal-title fs-5" id={`exampleModalLabel-${assignment._id}`}>{assignment.subject.subjectName} <span className="badge badge-secondary">Assignment.No:{assignment.assignmentNo}</span></h5>
                                    </div>
                                    <div className="modal-body">
                                      <form noValidate onSubmit={(e) => formHandler(e, assignment._id)}>
                                        <div className="card mb-3">
                                          <div className="card-body">
                                            <h5 className="card-title">{assignment.title}</h5>
                                            <p className="card-text">{assignment.description}</p>
                                            <p className="card-text"><small className="text-body-secondary">Due date: {new Date(assignment.submissionDate).toLocaleDateString()}</small></p>
                                          </div>
                                        </div>
                                        <table className="table table-bordered table-striped">
                                          <thead className="thead-dark">
                                            <tr>
                                              <th scope="col">S.NO</th>
                                              <th scope="col">Student Name</th>
                                              <th scope="col">Students Work</th>
                                              <th scope="col">Submission Date</th>
                                              <th scope="col">Mark</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {assignment.students.map((student, index) => (
                                              <tr key={index}>
                                                <td>{index+1}</td>
                                                <td>{getStudentName(student.studentId)}</td>
                                                <td>
                                                  <button
                                                    type="button"
                                                    className="btn btn-info text-light"
                                                    onClick={() => window.open(student.yourWorkLink, '_blank')}
                                                  >
                                                    Open
                                                  </button>
                                                </td>
                                                <td>{new Date(student.studentSubmissionDate).toLocaleString()}</td>
                                                <td>
                                                  {student.assignmentMark ? (
                                                    // Render mark if available
                                                    <h5 >{student.assignmentMark}</h5>
                                                  ) : (
                                                    // Render input field if mark is not available
                                                    <form noValidate onSubmit={(e) => formHandler3(e, assignment._id, student._id)}>
                                                      <div className="form-group">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          name="mark"
                                                          placeholder="Enter student mark"
                                                          required
                                                        />
                                                      </div>
                                                      <button type="submit" className="btn btn-success">
                                                        Upload
                                                      </button>
                                                    </form>
                                                  )}
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>


                                      </form>
                                    </div>
                                    <div className="modal-footer">
                                      <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                        Close
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        history.push('/')
      )}
    </div >
  );
};

export default FacultyAssignment;
